import React from "react";

export function AdminField({ label, children, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <span className="text-sm text-[var(--tv-muted)] mb-1.5 block">{label}</span>
      {children}
    </label>
  );
}

export function AdminTable({ columns, children }) {
  return (
    <div className="tv-card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[var(--tv-border)] bg-[rgba(255,255,255,0.02)]">
              {columns.map((col) => (
                <th key={col} className="text-left px-4 py-3 text-[var(--tv-muted)] font-medium">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
}

export function AdminModal({ open, title, onClose, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/80" onClick={onClose}>
      <div
        className="tv-card w-full max-w-2xl p-6 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-display font-bold text-xl text-white">{title}</h2>
          <button type="button" onClick={onClose} className="text-[var(--tv-muted)] hover:text-white text-sm">
            Kapat
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
